import { z } from 'zod';

/**
 * One entry of `GET /api/blacklist` — the frozen HTTP contract
 * (`testdata/golden/http-contracts/admin-misc.json` `admin.blacklist.list`, #147),
 * reproduced 1:1 by the Rust handler (`rust/server/src/routes/blacklist.rs`):
 * `id` is an opaque string (NOT necessarily a UUID), `licenseId` is nullable.
 */
export const blacklistEntrySchema = z.object({
  id: z.string(),
  serial: z.string(),
  reason: z.string(),
  licenseId: z.string().nullable(),
  createdAt: z.string(),
});

/**
 * `GET /api/blacklist` returns a bare array of entries (newest first) — there is
 * no pagination envelope on the wire; the page paginates the array locally.
 */
export const blacklistListSchema = z.array(blacklistEntrySchema);

export const blacklistAddSchema = z.object({
  serial: z.string().min(1, 'Serial is required'),
  reason: z.string().min(1, 'Reason is required').max(280, 'Reason must be 280 characters or less'),
});

export type BlacklistEntry = z.infer<typeof blacklistEntrySchema>;
export type BlacklistList = z.infer<typeof blacklistListSchema>;
export type BlacklistAdd = z.infer<typeof blacklistAddSchema>;
